import { Badge, type BadgeTone } from '@/components/Badge/Badge';
import type { CohortState } from '@/lib/api/types';

const TONES: Record<CohortState, BadgeTone> = {
  draft: 'neutral',
  scheduled: 'positive',
  live: 'live',
  expired: 'warning',
  archived: 'neutral',
};

export function CohortStateBadge({ state }: { state: CohortState }) {
  return <Badge tone={TONES[state]}>{state}</Badge>;
}
